import { Post } from "../home/Home";
import { Post as PostView } from "../Post/Post";
import { useContext, useEffect, useState } from "react";
import { AppContext } from "../../App";
import { collection, getDocs, query, where, documentId } from "firebase/firestore";
import { db, auth } from "../../config/firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import { CommentForm } from "./CommentForm";
import { Comment as CommentView } from "./Comment";
import "./Comments.css";
export interface Comment {
  parentCommentId: string;
  postId: string;
  text: string;
  userId: string;
  username: string;
  id: string;
}
export const Comments = () => {
  const { selectedPostId } = useContext(AppContext);
  const [post, setPost] = useState<Post | null>(null);
  const [comments, setComments] = useState<Comment[] | null>(null);
  const [user, loading, error] = useAuthState(auth);
  const postRef = collection(db, "posts");
  const commentRef = collection(db, "comments");

  const getPost = async () => {
    try {
      const postQuery = query(postRef, where(documentId(), "==", selectedPostId));
      const data = await getDocs(postQuery);
      const doc = data.docs[0];
      setPost({ ...doc.data(), id: doc.id } as Post);
    } catch (error) {
      console.log(error);
    }
  };
  const getComments = async () => {
    try {
      const commentsQuery = query(commentRef, where("postId", "==", selectedPostId));
      const data = await getDocs(commentsQuery);
      setComments(data.docs.map(doc => ({ ...doc.data(), id: doc.id } as Comment)));
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getPost();
    getComments();
  }, []);
  return (
    <div>
      {post && (
        <>
          <div className=''>
            <PostView
              post={{
                userId: post.userId,
                description: post.description,
                title: post.title,
                username: post.username,
                likeCount: post.likeCount,
                id: post.id,
              }}
            />
          </div>
          <div className='d-flex flex-column align-items-start mx-auto comment-section'>
            <h3 className='mt-3'>Reply:</h3>
            <CommentForm postId={post.id} commentId='' text='' getComments={getComments} />
            <h3 className='mt-2'>Comments:</h3>
            <div className='d-flex flex-column align-items-start align-content-start justify-content-center mt-1 w-100'>
              {comments?.map(c => (
                <>
                  <CommentView comment={c} getComments={getComments} />
                </>
              ))}
            </div>
          </div>
        </>
      )}
      {!post && <p className='alert alert-danger'>Something went wrong while loading post. Try again later.</p>}
    </div>
  );
};
